import React from "react";
import "./footer.css";

export default function Footer() {
  function getYear() {
    return new Date().getFullYear();
  }

  return (
    <footer className="footer footer-big footer-black">
      <div className="container">
        <div className="footer-copyright">
          © {getYear()} Vicus Capital
        </div>
        <div className="footer-privacy">
          We take protecting your data and privacy very seriously. As of
          January 1, 2020 the{" "}
          <a
            href="https://www.caprivacy.org/"
            target="_blank"
            rel="noopener noreferrer"
          >
            California Consumer Privacy Act (CCPA)
          </a>{" "}
          suggests the following link as an extra measure to safeguard your
          data:{" "}
          <a
            href="https://www.vicuscapital.com/donotsellmypersonalinformation"
            target="_blank"
            rel="noopener noreferrer"
          >
            Do not sell my personal information
          </a>
          .
        </div>
        <div className="footer-disclaimer">
          <p>
            <strong>
              FOR INTERNAL USE ONLY. NOT FOR USE WITH THE PUBLIC.
            </strong>
          </p>
          <p>
            Advisory Services offered through Vicus Capital, Inc., a federally
            Registered Investment Advisor.
          </p>
        </div>
      </div>
    </footer>
  );
}
